﻿import { Injectable } from "@angular/core";
import { HttpClient, HttpParams } from "@angular/common/http";
import { Router } from "@angular/router";
import { Observable } from "rxjs";
import { apiLink } from "../../../constant/api-link";

@Injectable()
export class AuthGuardJubiliService {

    constructor(
        private http: HttpClient,
        private router: Router
    ) { }

    checkUser(userSurrKey: number): Observable<boolean> {
        const url = apiLink.checkBackOfPermission;
        const params = new HttpParams()
            .set("userSurrKey", userSurrKey.toString());

        return this.http.get<boolean>(url, { params });

    }
}
